import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { RESOURCE_TYPE } from '../../config/const.config';

const ResourceType = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''}>
    <InputLabel id={`${id}-label`}>{label}</InputLabel>
    <Select
      labelId={`${id}-label`}
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      sx={sx}
    >
      {Object.keys(RESOURCE_TYPE).map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={RESOURCE_TYPE[k].value}>
          {RESOURCE_TYPE[k].label}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

ResourceType.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
ResourceType.defaultProps = {
  sx: {},
  error: '',
};

export default ResourceType;
